<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障期間</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障期間-1 -->
      <div class="mb-15">
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isBeginErr }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.begin"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isBeginUnitErr }"
          v-model="form.beginUnit"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePagePeriodGoodwish",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
